// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__miWNG","container":"Footer_container__12VmU","list":"Footer_list__2nbL9"};